import CustomHead from "@/components/atoms/CustomHead"
import { type SbHomePageStory } from "../../../../types"
import { StoryblokBlokLooper } from "../../../StoryblokBlokLooper"

type HomeTemplateProps = {
    story: SbHomePageStory
}

export function HomeTemplate({ story }: HomeTemplateProps) {
    const { blocks, metadata } = story.content.story?.content || {}

    return (
        <>
            <CustomHead
                title={metadata?.title}
                description={metadata?.description}
            />
            <StoryblokBlokLooper blocks={blocks || []} />
        </>
    )
}
